// Local collection identifiers. Content lives in src/data/strapi-content.json.
export const carouselEndpoint = 'carousels';
export const sdgEndpoint = 'sdgs';
export const bannerEndpoint = 'sdg-banners';
export const awardEndpoint = 'awards';
export const productEndpoint = 'products';
export const partnerEndpoint = 'partners';
export const teamEndpoint = 'teams';
export const advisorEndpoint = 'advisors';
export const articleEndpoint = 'articles';
